const generateUserAgreement = ({ name, company, email, date }) => `
YAPAY ZEKA TABANLI PROJE YAZIM ASİSTANI KULLANICI SÖZLEŞMESİ

Yürürlük Tarihi: ${date}

Taraflar:
- Hizmet Sağlayıcı: IDEATRUM YAPAY ZEKA MÜHENDİSLİK ARGE YAZILIM VE DANIŞMANLIK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ ("Hizmet Sağlayıcı")
- Kullanıcı: ${name} (${email}) - ${company}

1. AMAÇ VE KAPSAM
Bu sözleşme, ${name} tarafından, IDEATRUM YAPAY ZEKA MÜHENDİSLİK ARGE YAZILIM VE DANIŞMANLIK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ'nin sunduğu yapay zeka tabanlı proje yazım asistanı ("Hizmet") kapsamında sağlanan hizmetlerin kullanım koşullarını belirler. Bu hizmet; proje fikirlerinin, planlarının ve belgelerinin otomatik olarak oluşturulması ve yönetilmesi sürecinde kullanıcılara destek sağlar.

2. HİZMET TANIMI
Hizmet, kullanıcının sağladığı veri ve bilgilerden yararlanarak proje önerileri üretir. Kullanıcı girdileri analiz edilerek içerik önerileri sunulur, bu içerikler kullanıcı tarafından düzenlenebilir veya dışa aktarılabilir.

3. TOPLANAN KİŞİSEL VE TİCARİ VERİLER
Hizmet sırasında aşağıdaki bilgiler tarafımızca işlenebilir:
- Ad Soyad: ${name}
- E-posta Adresi: ${email}
- Şirket Unvanı: ${company}
- Proje Fikirleri ve İçerikleri
- Kullanım tarihleri, oturum kayıtları, tarayıcı bilgileri

4. VERİ İŞLEME AMAÇLARI
Toplanan veriler aşağıdaki amaçlarla işlenir:
- Hizmetin sunulması ve geliştirilmesi
- Yapay zekâ modellerinin eğitimi ve performans takibi (anonimleştirilmiş olarak)
- Teknik destek, müşteri hizmetleri
- Yasal yükümlülüklerin yerine getirilmesi

5. VERİLERİN EĞİTİMDE KULLANIMI
Kullanıcı, sağladığı proje fikirlerinin anonimleştirilerek yapay zeka sistemlerinin eğitimi ve hizmetin iyileştirilmesi amacıyla kullanılmasına açık rıza gösterir. Anonimleştirme işlemi sonrası, veriler hiçbir şekilde kullanıcıyla eşleştirilemez.

6. VERİ PAYLAŞIMI
Veriler, yalnızca aşağıdaki durumlarda kullanılır ve taraflarla paylaşılır:
- Teknik geliştirme ve güvenlik için dış hizmet sağlayıcıları (anonim veri ile sınırlıdır)
- Yasal merciler tarafından talep edilmesi durumunda
- Akademik veya araştırma amaçlı projelerde anonim veri olarak

7. SAKLAMA SÜRESİ
Veriler, kullanıcı hesabı aktif olduğu sürece ve yasal yükümlülüklerin gerektirdiği maksimum 5 yıl boyunca saklanabilir. Kullanıcı, hesabını silmek istediğinde, kişisel verileri de kalıcı olarak silinir veya anonim hale getirilir.

8. GÜVENLİK ÖNLEMLERİ
Hizmet sağlayıcı, verileri korumak için aşağıdaki önlemleri alır:
- TLS/SSL ile veri iletimi
- Kimlik doğrulama ve erişim kontrolü
- Periyodik güvenlik denetimleri

9. KULLANICININ HAKLARI
Kullanıcı aşağıdaki haklara sahiptir:
- Kendi verilerine erişim ve kopyasını isteme
- Verilerde düzeltme talep etme
- Veri işleme iznini dilediği zaman geri çekme
- Tüm verilerinin silinmesini talep etme

Bu haklar, IDEATRUM YAPAY ZEKA MÜHENDİSLİK ARGE YAZILIM VE DANIŞMANLIK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ'ne yazılı başvuru veya e-posta yoluyla kullanılabilir.

10. FİKRİ MÜLKİYET
Kullanıcı tarafından sağlanan içeriklerin fikri mülkiyeti ve bu içeriklerin kullanımından doğan tüm sorumluluk kullanıcıya aittir. Hizmet sağlayıcı, bu içerikleri yalnızca hizmet sunumu, analiz ve iyileştirme amaçları doğrultusunda kullanabilir.

11. SÖZLEŞMENİN SÜRESİ VE FESHİ
Bu sözleşme, ${date} tarihinde yürürlüğe girer ve kullanıcı veri işleme izinlerinin iptalini talep edene kadar geçerlidir. Kullanıcı, hizmeti kullanmayı bırakabilir ve sözleşmeyi sonlandırabilir. Hizmet sağlayıcı da dilediği zaman hizmeti sonlandırabilir.

12. UYUŞMAZLIKLARIN ÇÖZÜMÜ
Taraflar arasında doğabilecek uyuşmazlıklarda, İzmir Mahkemeleri ve İcra Daireleri yetkilidir.

---

KULLANICI ONAY BEYANI:

Ben, ${name} (${email}) – ${company}, bu sözleşmenin tamamını okuduğumu, anladığımı ve tüm koşulları kabul ettiğimi beyan ederim.

Onay Tarihi: ${date}
`;

export default generateUserAgreement;
